import * as React from 'react';
import * as FormUtils from '../formUtils/index';
import { useState, useReducer, useEffect, useRef, useContext } from 'react';

import { AppUserInfo, FileType } from "../../models/index";
import UserProfileService from '../../services/UserProfileService';
import AuthenticationContext from '../context/AuthenticationContext';
import { LetterHistory } from '../../models/LetterHistory';


const PAGE_SIZE = 10;

type UserLetterState = {
    letter: string,
    history: LetterHistory[]
}

export const UserLetter = (props: {
    user: AppUserInfo
}) => {

    const authCtx = useContext(AuthenticationContext);

    const letterIsAvailable = true;

    let [state, setState] = useReducer(
        (prevState: UserLetterState, newState: Partial<UserLetterState>) => ({ ...prevState, ...newState }),
        {
            letter: "",
            history: []
        }
    );

    const [historyId, setHistoryId] = useState(0);

    const getLetter = async (historyId: number) => {
        const letter = await UserProfileService.getLetter(props.user.id, historyId);

        if (!letter.hasErrors) {
            setState({
                letter: letter.value
            })
        }
    }

    const getHistory = async () => {
        const history = await UserProfileService.getLetterHistory(props.user.id);

        if (!history.hasErrors) {
            setState({
                history: history.value
            })
        }
    }

    const resetHistory = async () => {
        setHistoryId(0);
    }

    useEffect(() => {
        getLetter(0);

        getHistory();
    }, []);

    useEffect(() => {
        getLetter(historyId);
    }, [historyId]);

    return <div className="">
        <>
            {letterIsAvailable &&
                <>
                {state.history && <div>
                    <button className="btn btn-primary" style={{float: "right", marginTop: "28px;"}} onClick={resetHistory}>Show Current Letter</button>

                    <FormUtils.GroupSetDropdown<LetterHistory>
                        fieldName="userLetterId"
                        title="Letter History"
                        dropdownProps={{
                            dataSource: state.history,
                            getId: x => x.userLetterId,
                            renderItem: x => x.changeDate,
                            renderSelectedItem: x => x.changeDate,
                            selectedValue: historyId,
                            onSelectedItemChanged: (item) => {
                                if (item)
                                    setHistoryId(item.userLetterId);
                            }
                        }}
                    />

                </div>}
                <div dangerouslySetInnerHTML={{ __html: state.letter || '' }}></div>
            </>
             }
            {!letterIsAvailable &&
                <>
                    <p>Letters are currently inactive.</p>
                </>
            }
        </>
    </div>
};